import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, FormattedMessage } from 'react-intl';

const LOGOFILE_TOO_LARGE_ERROR = 'logoFile size is too large';
const UNSUPPORTED_FILE_TYPE_WARNING = 'Unsupported file type';

const messages = defineMessages({
  errorUploadingLogo: {
    description: 'Error message when uploading a logo',
    defaultMessage: 'The file you have chosen is too large. Please select a file with a size smaller than 100MB',
    id: 'WqgQNW',
  },
  unknownError: {
    description: 'Unknown error message when uploading a logo',
    defaultMessage: 'An unknown error occurred.',
    id: 'zqS0OD',
  },
  warningFileType: {
    description: 'Warning when the user selects a file type that is not supported',
    defaultMessage: 'File type is not supported',
    id: 'dI5SdP',
  },
});

const getUIErrorMessage = (errorResponse) => {
  if (!errorResponse?.Message) {
    return messages.unknownErrorWithoutMessage;
  }

  if (errorResponse.Message.includes(LOGOFILE_TOO_LARGE_ERROR)) {
    return {
      ...messages.errorUploadingLogo,
    };
  }

  if (errorResponse.Message.includes(UNSUPPORTED_FILE_TYPE_WARNING)) {
    return {
      ...messages.warningFileType,
    };
  }

  return {
    ...messages.unknownError,
  };
};

const LogoUploadErrorMessage = ({ error }) => {
  const messageDescriptor = getUIErrorMessage(error);

  return <FormattedMessage {...messageDescriptor} />;
};

LogoUploadErrorMessage.propTypes = {
  error: PropTypes.shape({
    Message: PropTypes.string,
  }).isRequired,
  minimumFundingAmount: PropTypes.object.isRequired,
};

export default LogoUploadErrorMessage;
